const mainurl="https://ddpi.almondztrade.com/api";
// const mainurl="http://192.168.68.123:8484/api"
// const mainurl="https://summary-repeatedly-kite.ngrok-free.app/api"
export default mainurl;